/**
 * Allow to update any setting individually using an AJAX request
 *
 * In the application, at the moment we are using this code with a check box, a select and
 * even a collection of links. But the code should be able to run correctly with whatever
 * element you want as long as you provide the correct event name. For instance, the event
 * 'blur' for a text input.
 *
 * The code assumes that given selector contains two data attributes:
 *
 * - url: the endpoint used to update a resource
 * - config: data to update a resource in JSON format
 *
 * In case the given selector is a select tag, then every option is expected to include a data
 * attribute 'track-label' with the desired value used to update the resource.
 *
 * Optionally you can force a page reload after a successful request and remove any filter present
 * in the current URL.
 */
export const SettingsUpdater = (
  selector,
  { eventName = "click", reloadPage = false, removeFilter = undefined } = {}
) => {
  const fields = document.querySelectorAll(selector);

  if (!fields.length) return;

  fields.forEach(field => {
    const { url, config } = field.dataset;

    field.addEventListener(
      eventName,
      function(e) {
        let data;

        switch (field.type) {
          case "checkbox":
            data = { ...JSON.parse(config), value: field.checked };
            break;

          case "select-one":
            data = {
              ...JSON.parse(config),
              value: field.options[field.selectedIndex].dataset.trackLabel,
            };
            break;

          default:
            data = JSON.parse(config);
        }

        $.ajax({
          url,
          type: "PUT",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify(data),
          complete: response => {
            if (!reloadPage || response.status !== 200) return;

            let newLocation;

            newLocation = window.location.href.replace(removeFilter, "");

            if (newLocation.includes("#")) {
              newLocation = newLocation.split("#")[0];
            }

            window.location.href = newLocation;
          },
        });
      },
      false
    );
  });
};
